export default "__VITE_ASSET__Bb5P6NR6__"